module.exports = __webpack_public_path__ + "static/media/jasmine-lose.a0f37a27.png";